import {
  useEffect,
  useState
} from "react";

import MainLayout
from "../../components/layout/MainLayout";

import {
  getProducts
} from "../../api/productApi";

import {
  getMaterials
} from "../../api/materialApi";

import {
  createProduction
} from "../../api/productionApi";

const ProductionOrders = () => {

  const [products,setProducts] =
  useState([]);

  const [materials,setMaterials] =
  useState([]);

  const [form,setForm] =
  useState({

    product_id:"",
    quantity:"",
    remarks:""

  });

  const [rows,setRows] =
  useState([

    {
      material_id:"",
      quantity:""
    }

  ]);

  useEffect(()=>{

    loadData();

  },[]);

  const loadData =
  async()=>{

    try{

      const productRes =
      await getProducts();

      const materialRes =
      await getMaterials();

      setProducts(
        productRes.data.data || []
      );

      setMaterials(
        materialRes.data.data || []
      );

    }
    catch(error){

      console.log(error);

    }

  };

  const addRow =
  ()=>{

    setRows([

      ...rows,

      {
        material_id:"",
        quantity:""
      }

    ]);

  };

  const removeRow =
  (index)=>{

    const updated =
    [...rows];

    updated.splice(
      index,
      1
    );

    setRows(updated);

  };

  const updateRow =
  (
    index,
    field,
    value
  )=>{

    const updated =
    [...rows];

    updated[index][field] =
    value;

    setRows(updated);

  };

  const saveProduction =
  async(e)=>{

    e.preventDefault();

    if(!form.product_id){

      return alert(
        "Select Product"
      );

    }

    if(!form.quantity){

      return alert(
        "Enter Production Quantity"
      );

    }

    try{

      await createProduction({

        ...form,

        materials:rows

      });

      alert(
        "Production Completed Successfully"
      );

      setForm({

        product_id:"",
        quantity:"",
        remarks:""

      });

      setRows([

        {
          material_id:"",
          quantity:""
        }

      ]);

    }
    catch(error){

      console.log(error);

      alert(
        "Failed To Complete Production"
      );

    }

  };

  return(

    <MainLayout>

      <div className="card shadow-sm border-0">

        <div className="card-header bg-white">

          <h5 className="mb-0">

            Production Order

          </h5>

        </div>

        <div className="card-body">

          <form
            onSubmit={saveProduction}
          >

            <div className="row">

              <div className="col-md-6 mb-3">

                <label className="form-label">

                  Product

                </label>

                <select
                  className="form-select"
                  value={form.product_id}
                  onChange={(e)=>
                    setForm({

                      ...form,

                      product_id:
                      e.target.value

                    })
                  }
                >

                  <option value="">
                    Select Product
                  </option>

                  {
                    products.map(
                      product=>(

                        <option
                          key={product.id}
                          value={product.id}
                        >

                          {
                            product.product_name
                          }

                        </option>

                      )
                    )
                  }

                </select>

              </div>

              <div className="col-md-6 mb-3">

                <label className="form-label">

                  Production Qty

                </label>

                <input
                  type="number"
                  className="form-control"
                  value={form.quantity}
                  onChange={(e)=>
                    setForm({

                      ...form,

                      quantity:
                      e.target.value

                    })
                  }
                />

              </div>

            </div>

            <div className="mb-3">

              <label className="form-label">

                Remarks

              </label>

              <textarea
                rows="3"
                className="form-control"
                value={form.remarks}
                onChange={(e)=>
                  setForm({

                    ...form,

                    remarks:
                    e.target.value

                  })
                }
              />

            </div>

            <hr />

            <div className="d-flex justify-content-between align-items-center mb-3">

              <h5>

                Materials Consumed

              </h5>

              <button
                type="button"
                className="btn btn-secondary"
                onClick={addRow}
              >

                Add Material

              </button>

            </div>

            <div className="table-responsive">

              <table className="table table-bordered">

                <thead className="table-light">

                  <tr>

                    <th>
                      Material
                    </th>

                    <th width="250">
                      Qty Used
                    </th>

                    <th width="120">
                      Action
                    </th>

                  </tr>

                </thead>

                <tbody>

                  {
                    rows.map(

                      (
                        row,
                        index
                      )=>(

                        <tr
                          key={index}
                        >

                          <td>

                            <select
                              className="form-select"
                              value={
                                row.material_id
                              }
                              onChange={(e)=>
                                updateRow(

                                  index,

                                  "material_id",

                                  e.target.value

                                )
                              }
                            >

                              <option value="">
                                Select Material
                              </option>

                              {
                                materials.map(
                                  material=>(

                                    <option
                                      key={material.id}
                                      value={material.id}
                                    >

                                      {
                                        material.material_name
                                      }

                                    </option>

                                  )
                                )
                              }

                            </select>

                          </td>

                          <td>

                            <input
                              type="number"
                              className="form-control"
                              value={
                                row.quantity
                              }
                              onChange={(e)=>
                                updateRow(

                                  index,

                                  "quantity",

                                  e.target.value

                                )
                              }
                            />

                          </td>

                          <td>

                            {
                              rows.length > 1 && (

                                <button
                                  type="button"
                                  className="btn btn-danger"
                                  onClick={()=>
                                    removeRow(
                                      index
                                    )
                                  }
                                >

                                  Remove

                                </button>

                              )
                            }

                          </td>

                        </tr>

                      )

                    )
                  }

                </tbody>

              </table>

            </div>

            <div className="text-end mt-4">

              <button
                type="submit"
                className="btn btn-primary btn-lg"
              >

                Complete Production

              </button>

            </div>

          </form>

        </div>

      </div>

    </MainLayout>

  );

};

export default ProductionOrders;
